import { logger } from '@/lib/logger';
import { useQueryClient } from '@tanstack/vue-query';
import { diagnosisKeys, diagnosisQueries } from '@therame/api-client';
import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';
import { useAuthStore } from './authStore';

type DiagnosisStore = {
  diagnosisFormsCompleted: Ref<boolean>;
  updateDiagnosisFormsCompleted: () => Promise<void>;
  reset: () => void;
};

export const useDiagnosisStore = defineStore('diagnosis', (): DiagnosisStore => {
  const diagnosisFormsCompleted = ref<boolean>(false);
  const queryClient = useQueryClient();

  const reset = () => {
    diagnosisFormsCompleted.value = false;
  };

  const updateDiagnosisFormsCompleted = async () => {
    const authStore = useAuthStore();
    try {
      const userId = authStore.authContext?.user.id!;
      await queryClient.fetchQuery({
        queryKey: diagnosisKeys.userDiagnosis(userId),
        queryFn: () => diagnosisQueries.getUserDiagnosis(userId),
      });
      diagnosisFormsCompleted.value = true;
    } catch (e) {
      // api returns 404 if no diagnosis forms are completed
      logger.error({ msg: 'Error updating diagnosis forms completed', error: e });
      diagnosisFormsCompleted.value = false;
    }
  };

  return {
    diagnosisFormsCompleted,
    updateDiagnosisFormsCompleted,
    reset,
  };
});
